module.exports = __webpack_public_path__ + "0abdc887a146531201d6d1939a207227.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GY.svg
// module id = rXKx
// module chunks = 0